import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
const styles = makeStyles(() => ({
  settingsMaintainerWrapper: {
    fontFamily: `'Manrope', sans-serif`,
  },
  userMaintainerHeader: {
    marginTop: 24,
    marginBottom: 28,
  },
  userMaintainerHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  sectionDimensions: {
    marginTop: "12px",
  },
  sectionTitleDimensions: {
    color: "#465869",
    fontSize: "16px",
    fontFamily: "Manrope",
    lineHeight: "18px",
    fontWeight: 700,
  },
  userMaintainerHeaderBreadcrumbTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontweight: "bold",
    color: "#38cfc4",
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
  },
  settingsMaintainerBody: {
    marginTop: 16,
  },
  userMaintainerBodySectionTitle: {
    fontFamily: "Manrope",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
    color: "#465869",
    marginBottom: "16px",
  },
  userMaintainerBodySection: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "40px",
    width: "100%",
    height: "auto",
  },

  userMaintainerFormControlLabel: {
    "& span:nth-child(2)": {
      color: "#465869",
      fontSize: 14,
      lineHeight: "24px",
      fontWeight: "normal",
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  userMaintainerActionLogoutUserButton: {
    background: "#FEE4E2",
    color: "#F97066",
    width: 144,
    height: 40,
    borderRadius: 8,
  },
  userMaintainerTimezoneMessage: {
    color: "#465869",
    fontSize: 12,
    lineHeight: "24px",
  },
  useMaintanerFooter: {
    marginTop: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  userMaintainerFooterButtonCancel: {
    background: "transperent",
    color: "#F97066",
    "&:hover": {
      background: "transperent",
      color: "#F97066",
    },
  },
  userMaintainerFooterButtonSave: {
    background: "#32d583",
    color: "#fff",
    borderRadius: 8,
    width: 63,
    height: 48,
    marginLeft: 16,
    "&:hover": {
      background: "#32d583",
      color: "#fff",
    },
  },
  userMaintainerActionStatusButton: {
    background: "#0055A4",
    color: "#fff",
    marginRight: 24,
    borderRadius: 8,
    width: 144,
    height: 40,
  },
  label: {
    color: "#0055A4",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "12px",
    fontFamily: "'Manrope', sans-serif",
  },
  input: {
    background: "#fff",
    height: 42,
    border: "1px solid #e4e7ec !important",
    borderRadius: 8,
    boxSizing: "border-box",
    padding: "6px 8px !important",
    width: "100%",
    "& input": {
      "&::placeholder": {
        color: "#9CA6AF !important",
        fontWeight: 500,
        fontSize: 12,
      },
    },
  },
  inputPhone: {
    "& input": {
      border: "none",
      borderLeft: "1px solid #e4e7ec",
      borderRadius: 0,
      paddingLeft: 8,
    },
  },
  inactiveItemIcon: {
    fontSize: 14,
    marginRight: 13,
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
    marginBottom: 18,
  },
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  tooltip: {
    lineHeight: "30px",
  },
  tooltipIcon: {
    fontSize: 16,
    color: "0055A4",
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
  listSpan: {
    display: "flex",
    alignItems: "center",
    color: "#0055A4",
  },
  removeListSpan: {
    display: "flex",
    alignItems: "center",
    color: "#D92D20",
  },
  chipBranch: {
    backgroundColor: "#EDF5FB",
    color: "#0055A4",
    margin: "2px",
  },
  chipLabel: {
    color: "#fff",
    background: "#0055A4",
    fontWeight: 600,
    marginBottom: 5,
  },
  chipLabelProject: {
    color: "#fff",
    background: "#0055A4",
    fontWeight: 600,
    marginTop: 5,
  },
  chipBox: {
    display: "flex",
    flexWrap: "wrap",
    textOverflow: "ellipsis",
    height: 40,
    alignItems: "center",
  },
  chipBoxProject: {
    display: "inline",
    flexWrap: "wrap",
    textOverflow: "ellipsis",
    height: 40,
    alignItems: "center",
  },
  customHr: {
    width: "100%",
    border: "1px solid #E0E2E7",
    backgroundColor: "#E0E2E7",
    marginTop: "40px",
  },
}));

export const StyledImage = styled("img")(() => ({
  width: "20px",
  height: "20px",
  cursor: "pointer",
}));

export const LeftTextContainer = styled("div")(() => ({
  maxWidth: "772px",
  width: "100%",
  whiteSpace: "normal",
  height: "100%",
  maxHeight: "40px",
  display: "flex",
  flexDirection: "column",

  alignItems: "flex-start",
  "@media (max-width: 600px)": {
    maxWidth: "100%",
    marginLeft: "0",
    maxHeight: "auto",
  },
}));

export const TextLeft = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  maxWidth: "772px",
  width: "100%",
  fontSize: "16px",
  whiteSpace: "normal",
  lineHeight: "24px",
  alignSelf: "stretch",
  letterSpacing: "0.5px",
  color: colors.gray600,
  "@media (max-width: 600px)": {
    maxWidth: "100%",
    fontSize: "14px",
    lineHeight: "20px",
  },
}));

export const TextLeftBottom = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  maxWidth: "772px",
  width: "100%",
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: colors.gray600,
  "@media (max-width: 600px)": {
    maxWidth: "100%",
    fontSize: "10px",
    lineHeight: "14px",
  },
}));

export const PasswordContainer = styled("div")(() => ({
  width: "100%",
  maxWidth: "1002px",
  height: "64px",
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  flexDirection: "row",
  backgroundColor: colors.gray50,
  padding: "12px 24px 12px 24px",
  borderRadius: "8px",
  borderColor: colors.gray200,
  border: "1px solid",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
    height: "100%",
  },
  "@media (min-width: 769px)": {
    flexDirection: "row",
    padding: "12px 24px 12px 24px",
  },
}));

export const TextRightContainer = styled("div")(() => ({
  display: "flex",
  height: "40px",
  padding: "10px 12px 10px 10px",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  flexShrink: 0,
  alignSelf: "stretch",
  cursor: "pointer",
  color: colors.blue700,
  "@media (max-width: 768px)": {
    width: "100%",
    marginLeft: "0",
    marginTop: "10px",
    justifyContent: "flex-start",
    padding: "0px 0px 0px 0px",
  },
}));

export const TextRight = styled("div")(() => ({
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  cursor: "pointer",
  color: colors.brandBlue500,
  "@media (max-width: 768px)": {
    fontSize: "12px",
    lineHeight: "18px",
    marginLeft: 0,
    justifyContent: "flex-start",
  },
}));

export default styles;
